module.exports = __webpack_public_path__ + "img/flamethrower-turret-gun-mask.636e9861.png";